import {
	Button,
	type PaletteColor,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { Check, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import { GRASS_GREEN_MYPLANN } from "web_myplann/Utils/constants";

type Props = {
	label: string;
	onClick: () => void;
	variant: "contained" | "text";
	/** Accent palette of the surrounding alert card (orange/blue). */
	accent: PaletteColor;
	/** Shown only on the contained (primary) button, per design. */
	Icon?: LucideIcon;
	subtext?: string;
};

export const EventActionButton: FC<Props> = ({
	label,
	onClick,
	variant,
	accent,
	Icon,
	subtext,
}) => {
	const { palette } = useTheme();

	return (
		<Stack alignItems="center" gap={0.4} width="100%">
			<Button
				variant={variant}
				fullWidth
				onClick={onClick}
				startIcon={
					variant === "contained" && Icon ? <Icon size={18} /> : undefined
				}
				sx={
					variant === "contained"
						? {
								backgroundColor: accent.main,
								color: accent.contrastText,
								borderRadius: "12px",
								height: 40,
								fontSize: 15,
								fontWeight: 600,
								textTransform: "none",
								"&:hover": { backgroundColor: accent.main },
								"&:active": { backgroundColor: accent.dark },
							}
						: {
								color: palette.grey[700],
								height: 40,
								fontSize: 14,
								fontWeight: 500,
								textTransform: "none",
							}
				}
			>
				{label}
			</Button>
			{subtext && (
				<Stack direction="row" alignItems="center" gap={0.4}>
					<Check size={14} color={GRASS_GREEN_MYPLANN} aria-hidden />
					<Typography variant="deprecatedHint" color={GRASS_GREEN_MYPLANN}>
						{subtext}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};
